import { render, staticRenderFns } from "./Sucesso.vue?vue&type=template&id=1556c7a6&scoped=true&"
import script from "./Sucesso.vue?vue&type=script&lang=js&"
export * from "./Sucesso.vue?vue&type=script&lang=js&"
import style0 from "./Sucesso.vue?vue&type=style&index=0&id=1556c7a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1556c7a6",
  null
  
)

export default component.exports